import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ADMIN_NAV_CONFIG, TESTING_ITEMS } from '../config/navigation';
import { useAuth } from '../context/AuthContext';
import { isProdEnv } from '../utils/env';
import './AdminDrawer.css';

// Right-side drawer for super_admin platform tooling. Keeps admin surface
// out of the daily practice sidebar while remaining one keystroke away.
// Opened via useAdminDrawer hook (Ctrl+Shift+A) or the sidebar footer button.
function AdminDrawer({ open, onClose }) {
  const { hasPermission } = useAuth();
  const location = useLocation();

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  useEffect(() => {
    onClose();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  if (!open) return null;

  return (
    <div className="admin-drawer__backdrop" onClick={onClose}>
      <aside className="admin-drawer" onClick={e => e.stopPropagation()} role="dialog" aria-label="Admin drawer">
        <div className="admin-drawer__head">
          <div>
            <div className="admin-drawer__title">Admin</div>
            <div className="admin-drawer__subtitle">Platform tooling (super_admin only)</div>
          </div>
          <button className="admin-drawer__close" onClick={onClose} aria-label="Close">×</button>
        </div>
        <div className="admin-drawer__body">
          {ADMIN_NAV_CONFIG.map(section => (
            <div key={section.label} className="admin-drawer__section">
              <div className="admin-drawer__section-label">{section.label}</div>
              {section.items
                .filter(item => !item.permission || hasPermission(item.permission))
                .map(item => (
                  <Link key={item.path} to={item.path} className="admin-drawer__link">
                    {item.label}
                  </Link>
                ))}
            </div>
          ))}
          {!isProdEnv() && (
            <div className="admin-drawer__section">
              <div className="admin-drawer__section-label">Test bench (non-prod)</div>
              {TESTING_ITEMS
                .filter(item => !item.permission || hasPermission(item.permission))
                .map(item => (
                  <Link key={item.path} to={item.path} className="admin-drawer__link">
                    {item.label}
                  </Link>
                ))}
            </div>
          )}
        </div>
        <div className="admin-drawer__foot">
          <kbd>Ctrl</kbd>+<kbd>Shift</kbd>+<kbd>A</kbd> to toggle · <kbd>Esc</kbd> to close
        </div>
      </aside>
    </div>
  );
}

export default AdminDrawer;
